import React from 'react'
import { VISITOR_VIEWS_FROM } from '../../Guard/Model/Model';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import ButtonSubAction from '../../../../../components/buttons/ButtonSubAction';
import { permissionObj } from '../../../../../Helpers/permission';
import { ArrowRightIcon } from '../../../../../components/buttons/IconButtons';
/**
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 */
/**
 * VisitorCardApp Component
 * This component is responsible for rendering the appropriate action button
 * based on the current visitor view (`viewOrigin`) and the visitor's status.
 */
export const VisitorCardApp = ({ viewOrigin, setShowRequestAccessModal, item,  goUpdate, DEV, permission, setSelectedList }) => {
  const renderVisitorButton = () => {
    if (viewOrigin === VISITOR_VIEWS_FROM.VISITOR_GUARD) {
        return (
            <div className='d-flex justify-content-center align-items-center gap-2 stretch-self w-100'>
                <ButtonAction
                    id='btn_vc_add'
                    name={'request_access'}
                    className='btn-icon-accent-450 flex-grow-1'
                    onClick={() => {
                        setSelectedList([item?.id]);
                        setShowRequestAccessModal(true)
                    }}
                    splitName={false}
                />
            </div>
        );
    }

    return (
        <div className='d-flex justify-content-end align-items-start gap-2 stretch-self w-100'>
            <ButtonSubAction
                id='btn_vtc_go'
                name={(!DEV && !permission.includes(permissionObj?.WEB_VISITOR_UPDATE))
                        ? 'details'
                        : 'update'
                }
                onClick={() => (!DEV && !permission.includes(permissionObj?.WEB_VISITOR_UPDATE))
                        ? goUpdate(item, true)
                        : goUpdate(item, false)
                }
                Icon={ArrowRightIcon}
            />
        </div>
    );
};

return {
     renderVisitorButton
    };
};
